import { ArticleHeader } from "@components/article/ArticleHeader"
import { defineBlock, EditableText, usePostEditor, usePostMetaEditor, usePostTitleEditor, useTemplate } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Hall of Fame Header",
  icon: "book-alt",
  inserter: false,
  postMetaBlock: {
    postTypes: ["hall-of-fame"],
    fieldName: "articleInfo",
  },
  flags: {
    fullWidth: true,
  },
}

export default defineBlock("article/hall-of-fame-header", (props) => {
  const template = useTemplate()

  return (
    <ArticleHeader
      mode={template === "single-article" ? "centered" : "editorial"}
      title={env.admin ? <EditableText store={usePostTitleEditor()} as="div" placeholder="Enter article title" /> : props.hallOfFameArticle?.title}
      subtitle={env.admin ? <EditableText store={usePostMetaEditor("subtitle")} as="div" placeholder="Optional subtitle" /> : props.hallOfFameArticle?.subtitle ?? ""}
      date={env.admin ? usePostEditor().post?.date : props.hallOfFameArticle?.date}
    />
  )
})
